import React, { useState, useEffect } from "react";
import {Button} from "react-bootstrap";
import { connectWallet, getCurrentWalletConnected } from "../utils/interact.js";

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY;
const contractABI = require("../contract-abi.json");
const contractAddress = "0x7340E290f9bE98E879200E53DA75469Eb2F5CA42";
const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
const web3 = createAlchemyWeb3(alchemyKey);
const contract = new web3.eth.Contract(contractABI, contractAddress);  

const mintNFT = async(amount, price) => {  
  const {address} = await getCurrentWalletConnected();
  if (address === "") {
    return {
      success: false, 
      status: "❗Please make sure wallet connected.",           
    }
  }  
  else {      
    contract.methods.mint(amount).send({from: address, gasPrice: 80000000000, gas: 380000*amount, value: (amount * price)})
    .on("confirmation", function () {      
    })
    .on('error', async function (error, receipt) {
      console.log(error);      
    }); 

    return {
      status: "",
    }   
    
  }
}    

const Mint = () => {
  const [walletAddress, setWallet] = useState("");  
  const [show, setShow] = useState(false);
  const [tokenNumber, setTokenNumber] = useState(1);
  const [status, setStatus] = useState(""); 
  const publicsale = true;
  const [supply, setSupply] = useState(0);

  const handleClose = () => setShow(false);  
  const publicsale_price = 80000000000000000;

  const handleShow = async () => {  
    setShow(true);   
  };

  const onMintHandle = () => {       
    setStatus("Mint not allowed!");
  };

  const decreaseTokenNumber = () => {
    if (tokenNumber === 1) {
      return;
    }
    setTokenNumber(tokenNumber - 1);
  }

  const onMintPressed = async () => {          
    const { status } = await mintNFT(tokenNumber, publicsale_price); 
      setStatus(status);         
  };

  useEffect(() => {    
    async function fetchData() {
      const {address} = await getCurrentWalletConnected();      
      contract.methods.totalSupply().call().then((_supply) => {        
        setSupply(_supply);
      }).catch((err) => console.log(err))
      setWallet(address);    
      addWalletListener(); 
    }
    fetchData();
  }, []);

  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);          
        } else {
          setWallet("");          
        }
      });
    } else {
         
    }
  } 

  const connectWalletPressed = async () => {
    const walletResponse = await connectWallet();    
    setWallet(walletResponse.address);
  };

  return (
    <div className="mint-container purple-text">
      <div className="mint-header text-center" id="mint">
        Mint
      </div>
      <div className="mint-panel">
        <div className="mint-header text-center">
          Shadow Descendants
        </div>
        <div className="mint-narration">
          Get you own crazy, funky, alien, amazing Vampires here. 
          They are here to make people panic after the pandemic and have a fun time within the community. 
          Our main goal is to find each of these Shadow Descendants a owner where they will battle it out between who is the most valueable out of all of them.
        </div>
        <div className="collage">
          <img src="./images/example.gif" alt="" width="150" height="150"/>
        </div>
        <div className="mint-price">
          Max per Tx 15<br />
          Only 0.08 Eth Each
        </div>
        <div className="text-center">
          <Button className="connect-btn mt-3" onClick={connectWalletPressed}>
            {walletAddress.length > 0 ? (                    
              "" +
              String(walletAddress).substring(0, 6) +
              "..." +
              String(walletAddress).substring(38)
              ) : (
                <span>Connect</span>
              )
            } 
          </Button>
        </div>
        <div className="mint-status text-center">
          {supply} / 10000 Sold Out 
        </div>
        <div className="text-center">
          <Button className="mint-btn mb-3 mb-md-5" onClick={handleShow}>
            Mint
          </Button>
        </div>
      </div>  
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Mint some Shadow Descendants</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src="./images/example.gif" alt="" style={{maxWidth: "220px"}}/>
          <div className="mint-number">
            <button type="button" onClick={decreaseTokenNumber}><span aria-hidden="true">-</span></button>
            <Form>
              <Form.Label>
                { tokenNumber }
              </Form.Label>                  
              {status ? <div>{status}</div> 
                : <div></div>}
            </Form>                
            {(tokenNumber < 20) ? <button type="button" onClick={() => setTokenNumber(tokenNumber + 1)}><span aria-hidden="true">+</span></button> 
              : <button type="button" onClick={() => setTokenNumber(tokenNumber)}><span aria-hidden="true">+</span></button>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          {(!publicsale) ? <Button variant="primary" onClick={onMintHandle}>Mint</Button> 
            : <Button variant="primary" onClick={onMintPressed}>Mint</Button>
          }              
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>               
    </div>
  );  
};

export default Mint;